/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CollectionNames } from '../models/CollectionNames';
import type { DeleteOneResponse } from '../models/DeleteOneResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DeleteService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * One Document By Id Or 404
     * Delete a single document from any collection by its `_id`.
     *
     * __Deletes document from MongoDB and not S3 buckets.__
     *
     * - collection_name (CollectionNames): Name of table in database.
     * - id (str): uuidv4 field of document in that table. This is the auto-generated MongoDB primary key.
     *
     * __Raises:__
     * - FrontendException: Custom exception for displaying feedback to user in frontend application.
     *
     * __Returns:__
     * - Response: Collection and id of deleted document.
     * @param collectionName
     * @param id
     * @returns DeleteOneResponse Delete one document from MongoDB by _id
     * @throws ApiError
     */
    public deleteOneDocumentByIdOr404(
        collectionName: CollectionNames,
        id: string
    ): CancelablePromise<DeleteOneResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v2/delete/{collection_name}/{id}',
            path: {
                collection_name: collectionName,
                id: id,
            },
            errors: {
                400: `Bad Request Error`,
                404: `An error occured while deleting the document`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Delete Db And S3 By Id
     * This endpoint does several things.
     *
     * 1. Deletes __all records from the NoSQL__ db for the given path params
     * 2. Deletes __all objects in S3__ associated with given path params
     * @param customerId
     * @param utilityId
     * @param documentId
     * @returns string Success
     * @throws ApiError
     */
    public deleteDeleteDbAndS3ById(
        customerId: string,
        utilityId: string,
        documentId: string
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v2/delete/{customer_id}/{utility_id}/{document_id}',
            path: {
                customer_id: customerId,
                utility_id: utilityId,
                document_id: documentId,
            },
            errors: {
                400: `Bad Request Error`,
                404: `Not Found Error`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
}
